// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3Vafc","vLegacy":"SelectSecondary_vLegacy__39ZgH","error":"SelectSecondary_error__1mmap","disabled":"SelectSecondary_disabled__npJNT"};